import React from 'react';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { apiService } from '../../services';
import { ReduxFormSmsID } from '../../components/Parcel';
import { Loading } from '../../components/GUI';
import { Page404 } from '../Page404';
import { errorToMessage, fixID } from '../../helpers';
import { Sms5KgDone } from './SmsDone';

class Sms5Kg extends React.Component {
  constructor(props) {
    super(props);
    this.state = { done: false };
  }

  componentDidMount() {
    this.getParcelBySMS();
  }

  getParcelBySMS() {
    const {
      getParcelBySMSAPI, match: { params: { parcelID } }
    } = this.props;

    const id = fixID(parcelID);
    if (!id) {
      this.setState({ error: 'תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.' });
      return;
    }

    apiService
      .callServer(
        getParcelBySMSAPI, { ':id:': id }, null, null, null, true
      )
      .then(
        _ => {
          this.setState({
            parcel: _
          });
        },
        error => {
          this.setState({
            error: errorToMessage(error)
          });
        }
      );
  }

  submit(values) {
    const {
      updateParcelBySMSAPI, match: { params: { parcelID } }
    } = this.props;

    apiService
      .callServer(
        updateParcelBySMSAPI, { ':id:': parcelID },
        null,
        JSON.stringify(values),
        null,
        true
      )
      .then(
        _ => {
          this.setState({ done: true });
        },
        error => {
          this.setState({
            error: errorToMessage(error), done: true
          });
        }
      );
  }

  renderError(error) {
    return (
      <Message
        className='error-message'
        error
        content={error}
      />
    );
  }

  render() {
    const { parcel, error, done } = this.state;

    if (error && !parcel) {
      return this.renderError(error);
    }

    let loading = true;
    let parcelFound = false;
    if (parcel) {
      parcelFound = true;
      loading = false;
    }

    return done ? (
      <div>
        {error ? this.renderError(error) : null}
        <Sms5KgDone isSuccess={!error} />
      </div>
    ) : loading ? (
      <Loading />
    ) : parcelFound ? (
      <div style={{ direction: 'rtl', width: '310px', margin: '0 auto' }}>
        <ReduxFormSmsID
          onSubmit={this.submit.bind(this)}
          parcel={parcel.description}
          buyer={parcel.buyerName}
          submitLabel={'אישור'}
        />
      </div>
    ) : (
      <Page404 />
    );
  }
}

function mapStateToProps(state) {
  const { getParcelBySMS, updateParcelBySMS } = state.api;
  return {
    getParcelBySMSAPI: getParcelBySMS,
    updateParcelBySMSAPI: updateParcelBySMS,
  };
}

// withRouter will set the location as this.props.location
const connectedSms5Kg = withRouter(connect(mapStateToProps)(Sms5Kg));
export { connectedSms5Kg as Sms5Kg };
